// The market will be either: UK or IE
// The page object containes two properties to be used to display market specific rich text: uk and roi
const getMarketRichTextContent = (market, page) => (market === 'IE' ? page?.roi : page?.uk) || '';

export default getMarketRichTextContent;
